var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V24C18 25.1046 17.1046 26 16 26H2C0.89543 26 0 25.1046 0 24V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16C22 14.8954 22.8954 14 24 14H38C39.1046 14 40 14.8954 40 16V38C40 39.1046 39.1046 40 38 40H24C22.8954 40 22 39.1046 22 38V16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 30.8954 0.895431 30 2 30H16C17.1046 30 18 30.8954 18 32V38C18 39.1046 17.1046 40 16 40H2C0.89543 40 0 39.1046 0 38V32Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2C22 0.89543 22.8954 0 24 0H38C39.1046 0 40 0.895431 40 2V8C40 9.10457 39.1046 10 38 10H24C22.8954 10 22 9.10457 22 8V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.b3aa62d192feab01b91b545d60aaeecc.svg";
export { ForwardRef as ReactComponent };